module.exports = __webpack_public_path__ + "media/images/pages/twitter_white-13d711f95f23c8a0b08135e538707ace.png";